import React from 'react';
import * as CONF from "../../../common/config";

const RecheckTable = ({ data = {} }) => {
 const signUrl = (path) => {
        if (!path) return '';
        return `${CONF.imgPrefix}${path}`;
    };
    const checklist = data.checklist || [];

    const recheckRows = [];

    checklist.forEach(item => {

        if (item.itemInfo?.length) {

            item.itemInfo.forEach(recheck => {

                recheckRows.push({
                    sortNo: item.sortNo,
                    itemContent: item.itemContent,
                    category: item.category,
                    ...recheck
                });

            });

        }

    });

    // 是否全部验收通过（所有检查项result为yes或not_applicable）
    const allPassed =
        checklist.length > 0 &&
        checklist.every(
            item => item.result === 'yes' || item.result === 'not_applicable'
        );

    // 最后一次复查记录
    const latestRecheck =
        recheckRows.length > 0
            ? recheckRows[recheckRows.length - 1]
            : null;

    return (
        <>
            <div className="recheck-title">
                复查记录单
            </div>

            <table className="inspection-table">
                <tbody>

                    <tr>
                        <td
                            rowSpan="2"
                            className="center w120"
                        >
                            隐患编号
                        </td>

                        <td
                            colSpan="3"
                            className="center"
                        >
                            整改情况
                        </td>

                        <td
                            colSpan="2"
                            className="center"
                        >
                            验收结论
                        </td>
                    </tr>

                    <tr>
                        <td className="center">
                            已整改
                        </td>

                        <td className="center">
                            未整改
                        </td>

                        <td className="center">
                            部分整改
                        </td>

                        <td className="center">
                            是
                        </td>

                        <td className="center">
                            否
                        </td>
                    </tr>

                    {
                        recheckRows.length > 0
                            ? recheckRows.map((item, index) => (
                                <tr key={index}>

                                    <td className="center">
                                        {item.sortNo}
                                    </td>

                                    <td className="center">
                                        {
                                            item.rectifyStatus === 'fixed'
                                                ? '√'
                                                : ''
                                        }
                                    </td>

                                    <td className="center">
                                        {
                                            item.rectifyStatus === 'unfixed'
                                                ? '√'
                                                : ''
                                        }
                                    </td>

                                    <td className="center">
                                        {
                                            item.rectifyStatus === 'partial'
                                                ? '√'
                                                : ''
                                        }
                                    </td>

                                    <td className="center">
                                        {
                                            item.acceptResult === 'yes'
                                                ? '√'
                                                : ''
                                        }
                                    </td>

                                    <td className="center">
                                        {
                                            item.acceptResult === 'no'
                                                ? '√'
                                                : ''
                                        }
                                    </td>

                                </tr>
                            ))
                            : (
                                [...Array(5)].map((_, idx) => (
                                    <tr key={idx}>
                                        <td>&nbsp;</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                ))
                            )
                    }

                </tbody>
            </table>

            {/* <div className="recheck-conclusion">

                <b>
                    复查结论：
                </b>

                <span>

                    {
                        allPassed
                            ? '☑'
                            : '☐'
                    }

                    全部整改合格，隐患闭环，验收通过

                </span>

                <span style={{ marginLeft: 40 }}>

                    {
                        !allPassed
                            ? '☑'
                            : '☐'
                    }

                    部分未完成，继续整改

                </span>

            </div> */}

            {recheckRows.length > 0 && (
            <table className="recheck-result-table">
                <tbody>

                    <tr>

                        <td className="result-label">
                            复查结论
                        </td>

                        <td>

                            <span className="result-item">

                                {allPassed ? '☑' : '☐'}

                                全部整改合格，隐患闭环，验收通过

                            </span>

                            <span className="result-item">

                                {!allPassed ? '☑' : '☐'}

                                部分未完成，继续整改

                            </span>

                        </td>

                    </tr>

                </tbody>
            </table>
            )}
            {recheckRows.length > 0 && (
            <table className="sign-table">
                <tbody>

                    <tr>

                        <td>

                            <div className="sign-inline">

                                <span>
                                    现场负责人（签字）：
                                </span>

                                {
                                    data?.siteManagerSign &&
                                    (
                                        <img
                                            src={signUrl(data.siteManagerSign)}
                                            alt=""
                                            className="sign-img"
                                        />
                                    )
                                }

                            </div>

                        </td>

                        <td>

                            <div className="sign-inline">

                                <span>
                                    排查人（签字）：
                                </span>

                                {
                                    data?.inspectorSign &&
                                    (
                                        <img
                                            src={signUrl(data.inspectorSign)}
                                            alt=""
                                            className="sign-img"
                                        />
                                    )
                                }
                                    {
                                        data?.inspector2Sign &&
                                        (
                                            <img
                                                src={signUrl(data.inspector2Sign)}
                                                alt=""
                                                className="sign-img"
                                            />
                                        )
                                    }

                            </div>

                        </td>

                    </tr>

                    <tr>

                        <td
                            colSpan="2"
                            className="center"
                        >
                            复查时间：
                            {latestRecheck?.createdAt || ''}
                        </td>

                    </tr>

                </tbody>
            </table>
            )}

        </>
    );
};

export default RecheckTable;